import React from "react";
import PropTypes from "prop-types";
import CardSkeleton from "../Skeleton/CardSkeleton";
import { classNames } from "../../../utils/helpers";
import Icon from "../../Icon";
import { FormatInt, FormatCurrency3Dec } from "../../../utils/FormatData";
const Card = (props) => {
  const {
    title,
    icon,
    loading,
    value,
    text,
    isCurrency = false,
    isSelected = false,
  } = props;

  if (loading) return <CardSkeleton />;
  return (
    <>
      <div
        className={classNames(
          "flex flex-col p-6 transition-all duration-300 transform rounded-lg bg-primary/10 dark:bg-primary/20 hover:scale-105 cursor-pointer",
          {
            "bg-blue-200": isSelected,
            "bg-white": !isSelected,
          },
        )}
      >
        <div className="flex items-center justify-between">
          <div className="text-lg font-bold text-gray-600 dark:text-background-light pb-3">
            {title}
          </div>
          <Icon icon={icon} className={classNames(text)} size={36} />
        </div>
        <p className="mt-2 text-3xl font-bold text-[#101922] dark:text-background-light">
          {isCurrency ? FormatCurrency3Dec(value) : FormatInt(value)}
        </p>
      </div>
    </>
  );
};

Card.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  value: PropTypes.number,
  text: PropTypes.string,
  isCurrency: PropTypes.bool,
  isSelected: PropTypes.bool,
};

export default Card;
